<!-- 布局-memu -->
<template>
  <div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <div
        :style="isCollapse ? '' : 'padding: 0 20px;'"
        class="scrollbar-transition"
      >
        <!-- 最多三级嵌套 -->
        <el-menu :default-active="nowPath" :collapse="isCollapse" router>
          <template v-for="(item, index) in appMenu">
            <el-menu-item
              :index="item.path"
              :key="index"
              v-if="item.children == 0 && item.meta && item.meta.isMenu == '1'"
            >
              <img
                :src="item.meta.activeIcon | getIcon"
                class="menu-icon"
                v-if="nowPath == item.path"
              />
              <img :src="item.meta.icon | getIcon" class="menu-icon" v-else />
              <span slot="title">{{ item.meta.title }}</span>
            </el-menu-item>

            <el-submenu
              :index="item.path"
              :key="index"
              v-else-if="item.meta && item.meta.isMenu == '1'"
            >
              <template slot="title">
                <img :src="item.meta.icon | getIcon" class="menu-icon" />
                <span slot="title">{{ item.meta.title }}</span>
              </template>
              <template v-for="(itemC, indexC) in item.children">
                <el-menu-item
                  :index="itemC.path"
                  :key="indexC"
                  v-if="itemC.children == 0 && itemC.meta && itemC.meta.isMenu == '1'"
                >
                  <span slot="title" style="padding-left:15px">{{
                    itemC.meta.title
                  }}</span>
                </el-menu-item>

                <el-submenu
                  :index="itemC.path"
                  :key="indexC"
                  v-else-if="itemC.meta && itemC.meta.isMenu == '1'"
                >
                  <span slot="title" style="padding-left:15px">{{
                    itemC.meta.title
                  }}</span>
                  <template v-for="(itemS, indexS) in itemC.children">
                    <el-menu-item
                      :key="indexS"
                      :index="itemS.path"
                      style="padding-left:15px"
                      v-if="itemS.meta && itemS.meta.isMenu == '1'"
                      >{{ itemS.meta.title }}</el-menu-item
                    >
                  </template>
                </el-submenu>
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {}
  },
  filters: {
    getIcon (name) {
      return require(`@/assets/images/${name}.png`)
    }
  },
  computed: {
    appMenu () {
      return this.$store.state.user.menuList
    },
    isCollapse () {
      return this.$store.state.app.isCollapse
    },
    nowPath () {
      if (this.isCollapse) {
        return ''
      }
      return this.$route.path
    }
  },
  watch: {},
  mounted () {

  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.scrollbar-transition {
  transition: all 0.4s;
}
.menu-icon {
  width: 20px;
  height: 20px;
  margin-right: 15px;
  object-fit: contain;
}
</style>
